import {createAsyncThunk} from "@reduxjs/toolkit";
import {HOSTNAME} from "../configs/Domain";
import {getAuthHeader} from "../store/utils";


export const listFiles = createAsyncThunk(
  'user/listFiles',
  async (_, { getState, rejectWithValue }) => {
    const { filesLoaded, files } = getState().user;
    if (!filesLoaded) {
        try {
            const response = await fetch(`${HOSTNAME}/files/list`, {
                method: "GET",
                headers: {
                    ...getAuthHeader(),
                }
            });
            const data = await response.json();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
    else{
        return files;
    }
  }
);



export const uploadFiles = createAsyncThunk(
  'user/uploadUserFiles',
  async ({ files, folderPath }, { rejectWithValue }) => {
    const formData = new FormData();
    files.forEach(file => formData.append('file', file.originFileObj)); // Use originFileObj
    if (folderPath) {
      formData.append('folder_path', folderPath);
    }


    try {
      const response = await fetch(`${HOSTNAME}/files/upload`, {
        method: 'POST',
        body: formData,
        headers: {
          ...getAuthHeader(),
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to upload files');
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const renameFile = createAsyncThunk(
  'files/renameFile',
  async ({ oldPath, newPath }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/files/rename/file`, {
        method: 'POST',
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ oldPath, newPath })
      });

      if (!response.ok) {
        throw new Error('Failed to rename file');
      }
      const responseData = await response.json();
      return {oldPath, newPath};
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const renameFolder = createAsyncThunk(
  'files/renameFolder',
  async ({ oldPath, newPath }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/files/rename/folder`, {
        method: 'POST',
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ oldPath, newPath })
      });

      if (!response.ok) {
        throw new Error('Failed to rename folder');
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteResources = createAsyncThunk(
  'files/deleteResources',
  async ({ paths }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/files/delete`, {
        method: 'POST',
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ paths })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to delete resources');
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



